//TODO: move it to shared utils
import { Image } from '@com-delta-idp/mnx-ui-kit';
import { ComponentType } from '../error-message.interfaces';

interface Action {
  label: string;
  url: string;
  id?: string;
}

interface ErrorCode {
  errorCode: string;
}

export interface AEMErrorMessage {
  action: Action;
  component: string;
  errorId: ErrorCode[];
  errorMessageDescription: string;
  errorMessageTitle: string;
  featureTitle: string;
  type: ComponentType;
  icon?: Image;
}

export interface AEMErrorMessagesSection {
  errorMessagesSection: {
    errormessages: AEMErrorMessage[];
  };
}
